// extracted by mini-css-extract-plugin
export default {"countryCodeBox":"CountryCodesDropdown_countryCodeBox__ymGsM","modalCountryCodebox":"CountryCodesDropdown_modalCountryCodebox__G1VFl"};